module.exports = __webpack_public_path__ + "img/banner.adcb1601.jpg";